export class SidebarPermissionsModel {
  projects = false;
  new_project = false;
  employees = false;
  clients = false;
  locations = false;
  agency_dashboard = false;
  agency_profile = false;
  agency_client = false;
  orders = false;
  create_order = false;
  view_staff = false;
  settings = false;
  work_validation_view = false;
  view_work_validation = false;
  payroll = false;
  supervisor_on_site = false;
  self_service = false;
  // JS-1920 follow-up (2026-11-03): client-only sidebar flag. True for agency users
  // regardless (backend always returns true for them). For client users, this gates the
  // Employees sidebar item + navigation to /self-service/employees. The filter/picker
  // surface in project-planning is NOT gated by this flag, so clients without it can
  // still use employees on self-service projects.
  view_employee_profile = false;
  // JS-1802: client name shown on the client portal sidebar; null for agency users.
  client_name: string = null;
}
